import * as Api from '@ViewModels';

export type BulkDeleteRequest =
	| { kind: 'ids'; itemIds: string[] }
	| {
			kind: 'filter';
			excludeItemIds: string[];
			filter?: Api.IOpportunitySearchRequest;
			stageId?: string;
			confirmWholeBoardDelete: boolean;
	  };

export const buildBulkDeleteRequest = ({
	isAllSelected,
	selectedRows,
	excludedRows,
	filter,
}: {
	isAllSelected: boolean;
	selectedRows: string[];
	excludedRows: string[];
	filter?: Api.IOpportunitySearchRequest;
}): BulkDeleteRequest | null => {
	if (isAllSelected) {
		return {
			kind: 'filter',
			excludeItemIds: excludedRows ?? [],
			filter: filter ?? undefined,
			stageId: filter?.stageId,
			confirmWholeBoardDelete: !filter,
		};
	}

	if (!selectedRows?.length) {
		return null;
	}

	return { kind: 'ids', itemIds: selectedRows };
};
